module.exports = __webpack_public_path__ + "static/media/Turbocharge.5059e9b3.png";